import { Controller } from "stimulus";
import { debounce } from 'lodash';

export default class extends Controller {

  static targets = ['searchField', 'searchForm', 'checkBox', 'selectAll', 'allPolicies', 'selectAllBtn', 'accordionToggle']

  initialize() {
    this.search = debounce(this.search, 1500).bind(this)
  }

  connect() {
    var childClicked = false;

    $(".legal-tooltip-link").on('click',function(){
      childClicked = true;
      let trainingId = $(this).data('training-id');
      $('.legal-tooltip').addClass('d-none');
       
      // Show the clicked tooltip
      $(".legal-tooltip-" + trainingId).removeClass('d-none');
    });

    $(".legal-tooltip-cross-icon").on('click',function(){
      childClicked = true;
      let trainingId = $(this).data('training-id');
      $(".legal-tooltip-" + trainingId).addClass('d-none');
    });

    $(".training-heart").children().click(function(e) {
      childClicked = true;
    });

    $(".tr-card").click(function(e) {
      if (e.currentTarget.querySelector(':scope > .tr-card-stretched-link')) {
        childClicked = false;
        return;
      }

      let companyId = e.currentTarget.dataset.companyId;
      let trainingId = e.currentTarget.dataset.trainingId;
      let publicLearner = e.currentTarget.dataset.publicLearner == 'true';
      let learnerId = e.currentTarget.dataset.learnerId;

      if(!childClicked) {
        window.location.href = publicLearner ? `/learners/${learnerId}/trainings/${trainingId}` : `/companies/${companyId}/trainings/${trainingId}`;
      }

      childClicked = false;
    });

    if (window.location.search.includes('wv_policy')) {
      $("#wv_congrats_modal").modal('show');
    }

    if (window.location.search.includes('assign_modal')) {
      $("#l-t-modal").modal('show');
    }

    if (window.location.search.includes('edit_info_modal')) {
      const companyId = this.element.getAttribute('data-company-id')
      const trainingId = this.element.getAttribute('data-training-id')
      const journeyId = this.element.getAttribute('data-journey-id')
      const journeyIdParam = journeyId ? `?coming_from_journey_id=${journeyId}` : ''
      this.removeModalParam('edit_info_modal')
      Rails.ajax({
        url: `/companies/${companyId}/trainings/${trainingId}/edit${journeyIdParam}`,
        type: "get",
        dataType: "script",
      })
    }

    $(document).on('click', function(event) {
      if (!$(event.target).closest('.legal-tooltip, .legal-tooltip-link').length) {
        $('.legal-tooltip').addClass('d-none');
      }
    });
  }

  removeModalParam(modalParam) {
    let url = new URL(window.location.href);
    url.searchParams.delete(modalParam);
    let newUrl = url.search ? url.href : url.href.replace('?', '');
    window.history.replaceState({}, document.title, newUrl);
  }

  search() {
    $('#search_spinner').removeClass('d-none')
    Rails.fire(this.searchFormTarget, 'submit');
  }

  handleAssign(event) {
    event.preventDefault();

    if ($('.learners-select').val().length == 0) {
      alert('Please select some learners.')
    } else {
      hideModalClasses();
      initializeDatePickers($('.daterangefull'));
      $('#renewal-modal').modal('show');
    }
  }

  redirectTo(event) {
    location.href = event.currentTarget.dataset.href;
  }

  toggleTableRowClass() {
    if (target.checked) {
      row.classList.add('table-active');
    } else {
      row.classList.remove('table-active');
    }
  }

  handleCheckboxSelect() {
    if(event.target.checked) {
      $(event.target).closest('.table_line').addClass('table-active');
    } else {
      $(event.target).closest('.table_line').removeClass('table-active');
      $('#policySelectAll').prop('checked', false);
    }
  }

  handleSelectAll() {
    if(event.target.checked) {

      $('.policy-checkbox').not(this).prop('checked', true);
      $('.table_line').addClass('table-active')
    } else {
      $('.policy-checkbox').not(this).prop('checked', false);
      $('.table_line').removeClass('table-active')
    }
  }

  toggleAccordionText(event) {
    const toggle = this.accordionToggleTarget;
    if (!toggle) return;

    const currentText = toggle.textContent;
    const newText = currentText === toggle.dataset.textHide ? toggle.dataset.textShow : toggle.dataset.textHide;
    toggle.textContent = newText;
  }

  previousPage(event) {
    event.preventDefault();
    const container = document.getElementById('mandated-banner-container');
    if (!container) {
      return;
    }

    const currentPage = parseInt(container.dataset.currentPage) || 1;
    const perPage = parseInt(container.dataset.perPage) || 5;

    if (currentPage > 1) {
      this.loadPage(currentPage - 1, perPage);
    }
  }

  nextPage(event) {
    event.preventDefault();
    const container = document.getElementById('mandated-banner-container');
    if (!container) {
      return;
    }

    const currentPage = parseInt(container.dataset.currentPage) || 1;
    const perPage = parseInt(container.dataset.perPage) || 5;
    this.loadPage(currentPage + 1, perPage);
  }

  changePerPage(event) {
    event.preventDefault();
    const perPage = parseInt(event.target.dataset.value);
    this.loadPage(1, perPage);
  }

  loadPage(page, perPage) {
    const trainingId = this.element.dataset.trainingId;
    const companyId = this.element.dataset.companyId;
    const url = `/companies/${companyId}/trainings/${trainingId}?page=${page}&per_page=${perPage}`;

    Rails.ajax({
      url: url,
      type: 'GET',
      dataType: 'script'
    });
  }
}
